$(document).ready(function () {

  if ($('.countdown-container').length) {
    $('.countdown-container').each(function () {
      var self = $(this);
      // March 9 2017 16:30:00 GMT-0700 (Phoenix Time)
      var endDate = new Date(self.data('end'));
      var end = $.now() + (endDate.getTime() - $.now()) / 1000;
      self.ClassyCountdown({
        theme: "white",
        end: end,
        now: $.now(),
        labels: true,
        labelsOptions: {
          lang: {
            days: 'Days',
            hours: 'Hours',
            minutes: 'Minutes',
            seconds: 'Seconds'
          },
        },
        style: {
          element: '',
          textResponsive: 0.5,
          days: {
            gauge: {
              thickness: 0.15,
              bgColor: "rgba(255,255,255,0.3)",
              fgColor: "#94C947"
            },
            textCSS: ''
          },
          hours: {
            gauge: {
              thickness: 0.15,
              bgColor: "rgba(255,255,255,0.3)",
              fgColor: "#94C947"
            },
            textCSS: ''
          },
          minutes: {
            gauge: {
              thickness: 0.15,
              bgColor: "rgba(255,255,255,0.3)",
              fgColor: "#94C947"
            },
            textCSS: ''
          },
          seconds: {
            gauge: {
              thickness: 0.15,
              bgColor: "rgba(255,255,255,0.3)",
              fgColor: "#94C947"
            },
            textCSS: ''
          }
        },
        onEndCallback: function () {
          self.closest('.countdown').find('.countdown--timer').hide();
          self.closest('.countdown').find('.countdown--after').show();
        }
      });
      var days = self.find('.ClassyCountdown-days');
      var daysVal = self.find('.ClassyCountdown-days .ClassyCountdown-value > div').html();
      var hours = self.find('.ClassyCountdown-hours');
      var hoursVal = self.find('.ClassyCountdown-hours .ClassyCountdown-value > div').html();
      var minutes = self.find('.ClassyCountdown-minutes');
      var minutesVal = self.find('.ClassyCountdown-minutes .ClassyCountdown-value > div').html();
      var seconds = self.find('.ClassyCountdown-seconds');
      var secondsVal = self.find('.ClassyCountdown-seconds .ClassyCountdown-value > div').html();
      if (daysVal > 0) {
        days.addClass('show');
      }
      if (hoursVal > 0 || daysVal > 0) {
        hours.addClass('show');
      }
      if (minutesVal > 0 || daysVal < 1) {
        minutes.addClass('show');
      }
      // if (hoursVal <= 0 && daysVal <= 0 && minutesVal > 0) {
      // 	minutes.addClass('show');
      // }
      if (hoursVal <= 0 && daysVal <= 0 && secondsVal > 0) {
        seconds.addClass('show');
      }
    });

    $(window).trigger('resize');
  }

});